import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconArrowSplitLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="arrow-split-left, rules, direction, split"><path d="M9.25 20.25H3.75V14.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 9.25V3.75H9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12 12H20.25M12 12L4.5 19.5M12 12L4.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconArrowSplitLeft;
